<div class="sections">
    <div>
        <form [formGroup]="form">
            <div class="field">
                <h4>Bank transit</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="bankTransit"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('bankTransit', true)"
                           (focusout)="activeExplanationChange('bankTransit', false)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'bankTransit') === 'required'">Bank transit is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'bankTransit') === 'digitCount'">Must be exactly 9 digits</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Bank account number</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="bankAccountNumber"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('bankAccountNumber', true)"
                           (focusout)="activeExplanationChange('bankAccountNumber', false)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'bankAccountNumber') === 'required'">Account number is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'bankAccountNumber') === 'digitCount'">Must be between 8 and 15 digits</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Bank account associated address</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="trigger-area" (click)="associatedAddressAutocomplete.isOpen ? associatedAddressTrigger.closePanel() : associatedAddressTrigger.openPanel()"></div>
                        <input matInput #associatedAddressInput
                           [matAutocomplete]="associatedAddressAutocomplete"
                           #associatedAddressTrigger="matAutocompleteTrigger"
                           [anchorAutocompleteOnScroll]="associatedAddressTrigger"
                           formControlName="associatedAddress"
                           autocomplete="off"
                           name="avoidSearch"
                               (focus)="associatedAddressInput.blur()"
                           enterkeyhint="next"
                        />
                        <mat-icon matSuffix class="rotate" [class.do]="associatedAddressAutocomplete.isOpen">expand_more</mat-icon>
                    </div>
                    <mat-autocomplete #associatedAddressAutocomplete="matAutocomplete"
                                      (opened)="activeExplanationChange('associatedAddress', true)"
                                      (closed)="activeExplanationChange('associatedAddress', false)"
                    >
                        <mat-option value="DBA">
                            DBA
                        </mat-option>
                        <mat-option value="Legal">
                            Legal
                        </mat-option>
                        <mat-option value="None">
                            None
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formControlError(form, 'associatedAddress') === 'required'">Account associated address is required</mat-error>
                </mat-form-field>
            </div>
        </form>
        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>